import { type DropdownMenuOption } from '@air/primitive-dropdown-menu';
import { itemIsSelectedSelector, selectedItemsCountSelector } from '@air/redux-selected-items';

import { useWorkspaceAgentMenuDropdownClassName } from '~/components/v2/components/workspace/workspace-agent-panel/hooks/useWorkspaceAgentMenuDropdownClassName';
import { useAirSelector, useAirStore } from '~/utils/ReduxUtils';

export type UseSelectionAwareContextMenuParams = {
  contextMenuOptions: DropdownMenuOption[];
  id: string;
  selectionMenuOptions: DropdownMenuOption[];
};

export const useSelectionAwareContextMenuOptions = ({
  id,
  contextMenuOptions,
  selectionMenuOptions,
}: UseSelectionAwareContextMenuParams) => {
  const store = useAirStore();
  const isSelected = useAirSelector((st) => itemIsSelectedSelector(st, id));
  const selectedCount = selectedItemsCountSelector(store.getState());
  const { selectionMenuDropdownClassName } = useWorkspaceAgentMenuDropdownClassName();

  const isMultiSelectContextMenu = selectedCount > 1 && isSelected;

  return {
    contentClassName: isMultiSelectContextMenu ? selectionMenuDropdownClassName : undefined,
    options: isMultiSelectContextMenu ? selectionMenuOptions : contextMenuOptions,
  };
};
